@switch (media.type) {
  @case (fileType.ImageSvg) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.ImagePng) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.ImageJpeg) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.ImageGif) {
    <ng-container [ngTemplateOutlet]="imageMedia"></ng-container>
  }
  @case (fileType.AudioMp3) {
    <ng-container [ngTemplateOutlet]="videoMedia"></ng-container>
  }
  @case (fileType.VideoMp4) {
    <ng-container [ngTemplateOutlet]="videoMedia"></ng-container>
  }
}

<ng-template #videoMedia>
  @if (!isExpanded) {
    <fa-icon class="media-type" [icon]="faVideo"></fa-icon>
  }
  <video [width]="size.width" [height]="size.height" [controls]="isExpanded" [controlsList]="['nodownload', 'noremoteplayback', 'nofullscreen']">
    <source [src]="url" [type]="media.type" />
    Your browser does not support the video tag.
  </video>
</ng-template>

<ng-template #imageMedia>
  @if (isExpanded) {
    <img eiq-media-broken [id]="media.id" [alt]="media.name" [ngSrc]="url" fill class="stimulus__image isExpanded" />
  } @else {
    <fa-icon class="media-type" [icon]="faImage"></fa-icon>
    <img eiq-media-broken [id]="media.id" [alt]="media.name" [ngSrc]="url" fill class="stimulus__image" />
  }
</ng-template>
